const API_URL = process.env.REACT_APP_API_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
const security_key = process.env.REACT_APP_API_KEY;

export { API_URL, BASE_URL, IMAGE_URL, security_key };
